import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Lock } from "lucide-react";

// Shared privacy selector used by PaperRoller, CharacterSheetFull and GenericDiceRoller.
// value: { is_private: bool, whisper_target_member_id: string|null }
export default function RollPrivacyControl({ isGm, members, myMemberId, value, onChange }) {
  const others = (members || []).filter((m) => m.id !== myMemberId && m.role !== "gm");

  if (isGm) {
    const mode = value.whisper_target_member_id ? "secret" : value.is_private ? "private" : "public";
    return (
      <div className="flex items-center gap-2" data-testid="roll-privacy-control-gm">
        <Select
          value={mode}
          onValueChange={(v) => {
            if (v === "public") onChange({ is_private: false, whisper_target_member_id: null });
            else if (v === "private") onChange({ is_private: true, whisper_target_member_id: null });
            else onChange({ is_private: true, whisper_target_member_id: value.whisper_target_member_id || others[0]?.id || null });
          }}
        >
          <SelectTrigger data-testid="roll-privacy-mode-select" className="h-9 w-[150px] bg-black/30 border-white/10 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem data-testid="roll-privacy-mode-public" value="public">Public</SelectItem>
            <SelectItem data-testid="roll-privacy-mode-private" value="private">Private (GM only)</SelectItem>
            <SelectItem data-testid="roll-privacy-mode-secret" value="secret">Secret to player…</SelectItem>
          </SelectContent>
        </Select>
        {mode === "secret" && (
          <Select value={value.whisper_target_member_id || ""} onValueChange={(v) => onChange({ is_private: true, whisper_target_member_id: v })}>
            <SelectTrigger data-testid="roll-privacy-target-select" className="h-9 w-32 bg-black/30 border-white/10 text-xs">
              <SelectValue placeholder="Pick player" />
            </SelectTrigger>
            <SelectContent>
              {others.map((m) => (
                <SelectItem key={m.id} value={m.id} data-testid={`roll-privacy-target-${m.id}`}>{m.display_name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
    );
  }

  return (
    <button
      data-testid="roll-privacy-toggle-player"
      onClick={() => onChange({ is_private: !value.is_private, whisper_target_member_id: null })}
      className={`flex items-center gap-2 h-9 px-3 rounded-full border text-xs uppercase tracking-widest transition-colors duration-200 ${
        value.is_private ? "bg-[#D4AF37]/15 border-[#D4AF37] text-[#D4AF37]" : "bg-black/30 border-white/10 text-[#f1e0c5]/40 hover:border-[#D4AF37]/40"
      }`}
    >
      <Lock className="w-3.5 h-3.5" /> {value.is_private ? "Private (you + GM)" : "Private roll (off)"}
    </button>
  );
}
